import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const FourBlockIconTextGrid = ({
  key,
  heading=null,
  content=null,
  blocksPosition="right",
  ctaButtonText=null,
  ctaButtonLink=null,
  iconTextBlocks=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className={ `four-block-icon-with-text-grid-content ${blocksPosition}` }>
      <div className={ `col-12 aifs d-flex flex-wrap ph0 ${blocksPosition} ${blocksPosition === 'left' ? "jcfe" : "jcfs"}` }>
        <div className="col-12 col-md-6 four-block-content ph0">
          <div className="content-col-responsive">
            <div className="col-12 col-md-8 col-xl-6 offset-md-2 offset-xl-3 parallax-text-content ph0">
              {heading &&
                <h2 className={ `content-title white ${content ? "orange-dash" : ""}` }>{ htmlDecode(heading) }</h2>
              }
              {content &&
                <div className="section-content white" dangerouslySetInnerHTML={{ __html: content }} />
              }
              {ctaButtonText && ctaButtonLink &&
                <div className="btn-row d-flex">
                  <Link href={ ctaButtonLink } className="button inverse inverse-alt mr2">{ ctaButtonText }</Link>
                </div>
              }
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 four-block-image-content">
          {iconTextBlocks && iconTextBlocks.map((block, index) => (
            <div className="image-content-inner col-16 col-md-6">
              <div className="block bgw">
                {block.icon &&
                  <div className="img-container">
                    {block.icon?.formats?.small &&
                      <img src= {block.icon.formats.small.url.includes(cdnUrl) ? block.icon.formats.small.url : cdnUrl + block.icon.formats.small.url} alt={ block.icon?.alternativeText } />
                    }
                    {!block.icon?.formats?.small &&
                      <img src= {block.icon.url.includes(cdnUrl) ? block.icon.url : cdnUrl + block.icon.url} alt={ block.icon?.alternativeText } />
                    }
                  </div>
                }
                {block.title &&
                  <h2 className="four-block-title">{ htmlDecode(block.title) }</h2>
                }
                {block.content &&
                  <div className="section-content smaller" dangerouslySetInnerHTML={{ __html: block.content }} />
                }
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FourBlockIconTextGrid
